<template>
  <div
    class="bg-primary container-fluid h-100 d-flex align-items-center justify-content-center"
    style="min-height: calc(100vh - 5rem)"
    data-cy="pagamento-bg-container"
  >
    <div class="col-md-8 col-lg-4 col-xl-4" data-cy="pagamento-main-col">
      <div class="card rounded-0" data-cy="pagamento-card">
        <div
          class="card-body p-lg-5 d-flex flex-column"
          data-cy="pagamento-card-body"
        >
          <div class="text-center" data-cy="pagamento-title-container">
            <h4
              class="text-primary font-weight-bold mb-0"
              data-cy="pagamento-title"
            >
              Orientações para Pagamento
            </h4>
          </div>
          <b-jumbotron
            v-html="get_telemedicine_message"
            style="padding: 2rem 1rem;"
            data-cy="pagamento-jumbotron"
          >
          </b-jumbotron>
          <div
            class="d-flex flex-row"
            v-if="!get_anexado_comprovante"
            data-cy="pagamento-form-row"
          >
            <b-card class="mb-4" data-cy="pagamento-form-card">
              <b-card-title data-cy="pagamento-form-title">
                Envio do Comprovante - Transferência
              </b-card-title>
              <b-card-body data-cy="pagamento-form-body">
                <div
                  class="d-flex flex-column"
                  style="color: orange;"
                  v-if="errors.length > 0"
                  data-cy="pagamento-error-list-container"
                >
                  <ul data-cy="pagamento-error-list">
                    <li
                      v-for="error in errors"
                      :key="error"
                      :data-cy="`pagamento-error-${error}`"
                    >
                      {{ error }}
                    </li>
                  </ul>
                </div>
                <b-form @submit.prevent="submit" data-cy="pagamento-form">
                  <b-form-group
                    label="Comprovante:"
                    label-for="comprovante"
                    data-cy="pagamento-form-group-comprovante"
                  >
                    <b-form-file
                      id="comprovante"
                      accept="image/*, application/pdf"
                      ref="comprovante"
                      v-model="comprovante"
                      required
                      placeholder="Comprovante de Transferência"
                      data-cy="pagamento-form-file-comprovante"
                    ></b-form-file>
                    <small data-cy="pagamento-form-file-hint"
                      ><em>Tamanho máximo do arquivo deve ser 8MB</em></small
                    >
                  </b-form-group>
                  <b-form-group
                    label="Observação:"
                    label-for="observacao"
                    data-cy="pagamento-form-group-observacao"
                  >
                    <b-form-textarea
                      id="observacao"
                      placeholder="Alguma observação?"
                      v-model="pagamento.observacao"
                      data-cy="pagamento-form-textarea-observacao"
                    ></b-form-textarea>
                  </b-form-group>
                  <b-button
                    type="submit"
                    variant="primary"
                    data-cy="pagamento-form-btn-enviar"
                    >Enviar Comprovante</b-button
                  >
                </b-form>
              </b-card-body>
            </b-card>
          </div>
          <div
            class="d-flex flex-column"
            v-if="get_anexado_comprovante"
            data-cy="pagamento-confirm-row"
          >
            <router-link
              v-if="get_telemedicine_message"
              :to="{
                name: 'index',
                params: { organizationId: $route.params.organizationId }
              }"
              class="btn btn-primary btn-lg rounded-0 d-flex justify-content-center align-items-center my-3"
              data-cy="pagamento-confirm-link"
            >
              Obrigado por enviar! Iremos analisar!
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "payment",
  data() {
    return {
      errors: [],
      pagamento: {},
      comprovante: null
    };
  },
  computed: {
    ...mapGetters([
      "get_agendamento",
      "get_telemedicine_message",
      "get_anexado_comprovante",
      "get_selected"
    ])
  },
  methods: {
    submit() {
      this.errors = [];

      if (this.comprovante.size > 8 * 1024 * 1024) {
        this.errors.push("O tamanho máximo do comprovante deve ser 8MB.");
      }

      if (this.errors.length) {
        return;
      }

      const { observacao, marcacao } = this.pagamento;
      let formData = new FormData();
      formData.append("anexo", this.comprovante);
      formData.append("observacao", observacao || "");
      formData.append("marcacao", marcacao);
      const payload = {
        url: this.$serverHost,
        params: {
          organizationId: this.$route.params.organizationId
        },
        data: formData
      };
      this.$store.dispatch("confirm_payment", payload);
    }
  },
  mounted() {
    this.$store.dispatch("reset_anexado_comprovante");
    this.pagamento.marcacao = this.$route.query.marcacaoId;
    this.$store.dispatch("load_telemedicine_message", {
      url: `${this.$serverHost}geral/instrucaoTelemedicina`,
      params: {
        marcacaoId: this.$route.query.marcacaoId,
        organizationId: this.$route.params.organizationId
      }
    });
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    get_agendamento(newValue, oldValue) {
      this.pagamento.marcacao = newValue.id;
    }
  }
};
</script>

<style></style>
